import { AbstractControl, ValidationErrors } from '@angular/forms';

import { delay, Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { JobBoardCredentialHttpClient } from '@recruitee/job-boards-data';

export function validateCorporateEmail(credentialHttpClient: JobBoardCredentialHttpClient) {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const value = control.value.toLowerCase();

    return of(control.value).pipe(
      delay(250),
      switchMap(() => credentialHttpClient.validateCorporateEmail(value)),
      catchError(() => of({ ...control.errors, corporateEmailInvalid: true })),
    );
  };
}
